<router-outlet></router-outlet>
<simple-notifications></simple-notifications>
<img alt="" [src]="'sb-tools/theme/images/emojis/apple_32.png'" hidden />
